/**
 * AdminLiveVisitors - DEPRECATED
 * 
 * This component was part of the vendor referral analytics system
 * which has been completely removed (March 2026).
 * 
 * The live visitor tracking and vendor duty assignment features
 * are no longer available after the vendedor system simplification.
 */
import DashboardLayout from "../../components/DashboardLayout";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

const AdminLiveVisitors = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-8 max-w-md">
          <AlertCircle className="w-16 h-16 text-amber-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Funcionalidad Descontinuada
          </h2>
          <p className="text-gray-600 mb-6">
            El sistema de monitoreo de visitantes en vivo fue parte del sistema de vendedores, 
            el cual ha sido simplificado. Esta funcionalidad ya no está disponible.
          </p>
          <Button 
            onClick={() => navigate("/admin")}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver al Panel Principal
          </Button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminLiveVisitors;
